











import { Vue, Component } from "@/shared/vuepack";
import OktaFactorSettings from "@/shared/components/OktaFactorSettings.vue";

@Component({
  components: {
    OktaFactorSettings
  }
})
export default class PartnerSecurity extends Vue {}
